import axios from "axios";

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/billing";

export const getBillingGroupsByUser = async (userPublicId, apiAccessToken) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingGroup/get-billing-groups-by-user/${userPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch billingGroups"
    );
  }
};

export const getBillingGroupsByLicense = async (
  licensePublicId,
  apiAccessToken
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingGroup/get-billing-groups-by-license/${licensePublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch billingGroups"
    );
  }
};

export const getBillingGroupsByAgreement = async (agreementPublicId, apiAccessToken) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingGroup/get-billing-groups-by-agreement/${agreementPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch billingGroups"
    );
  }
};

export const getBillingGroup = async (billingGroupPublicId, apiAccessToken) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingGroup/get-billing-group/${billingGroupPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch billingGroup"
    );
  }
}

//POST
export const createBillingGroup = async (billingGroupData, apiAccessToken) => {
  try {
    const response = await axios.post(
      `${baseUrl}/BillingGroup/create-billing-group`,
      billingGroupData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to create billingGroup"
    );
  }
};

//PUT
export const updateBillingGroup = async (billingGroupData, apiAccessToken) => {
  try {
    const response = await axios.put(
      `${baseUrl}/BillingGroup/update-billing-group`,
      billingGroupData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to update billingGroup"
    );
  }
};

//DELETE
export const deleteBillingGroup = async (billingGroupPublicId, apiAccessToken) => {
  try {
    const response = await axios.delete(
      `${baseUrl}/BillingGroup/delete-billing-group/${billingGroupPublicId}`,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to delete billingGroup"
    );
  }
};


// BILLINGHISTORY

export const getBillingHistoryByAgreement = async (
  agreementPublicId,
  apiAccessToken
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingHistory/get-billing-history-by-agreement-id/${agreementPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch history&billing"
    );
  }
};

export const getAllBillingHistory = async (
  apiAccessToken
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/BillingHistory/get-all-billing-history`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch all billing history"
    );
  }
};

export const createBillingHistory = async (
  apiAccessToken,
  data
) => {
  try {
    const response = await axios.post(
      `${baseUrl}/BillingHistory/create-billing-history`, data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch all billing history"
    );
  }
};

export const getBillingHistoryDetailsByBillingHistory = async (
  billingHistoryPublicId,
  apiAccessToken
) => {
  console.log("API Call:", `${baseUrl}/BillingHistory/get-billing-history-details-by-billing-history-id/${billingHistoryPublicId}`);

  try {
    const response = await axios.get(
      `${baseUrl}/BillingHistory/get-billing-history-details-by-billing-history-id/${billingHistoryPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );    
    
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch history&billing"
    );
  }
};

// POST

export const createHistoryAndBilling = async (apiAccessToken, body) => {
  try {
    const response = await axios.post(`${baseUrl}/BillingHistory/create-billing-history`, body, {
      headers: { 
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
       },
    });
    console.log("Response:", response.data);
    return response.data;

  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create history and billing"
    );
  }

  
};

//DELETE
export const deleteHistoryBilling = async (historyBillingPublicId, apiAccessToken) => {
  try {
    const response = await axios.delete(
      `${baseUrl}/BillingHistory/delete-billing-history/${historyBillingPublicId}`,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to delete historyBilling"
    );
  }
};




// INDEXADJUSTMENTS

//GET
export const getIndexAdjustmentsByAgreement = async (
  agreementPublicId,
  apiAccessToken
) => {
  try {
    const response = await axios.get(
      `${baseUrl}/IndexAdjustment/get-index-adjustments-by-agreement/${agreementPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch indexAdjustments"
    );
  }
};

export const getIndexAdjustment = async (indexAdjustmentPublicId, apiAccessToken) => {
  try {
    const response = await axios.get(
      `${baseUrl}/IndexAdjustment/get-index-adjustment/${indexAdjustmentPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to fetch indexAdjustment"
    );
  }
}

//POST
export const createIndexAdjustment = async (indexAdjustmentData, apiAccessToken) => {
  try {
    const response = await axios.post(
      `${baseUrl}/IndexAdjustment/create-index-adjustment`,
      indexAdjustmentData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to create indexAdjustment"
    );
  }
};

// PUT
export const updateIndexAdjustment = async (indexAdjustmentData, apiAccessToken) => {
  try {
    const response = await axios.put(
      `${baseUrl}/IndexAdjustment/update-index-adjustment`,
      indexAdjustmentData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to update indexAdjustment"
    );
  }
};

// DELETE
export const deleteIndexAdjustment = async (indexAdjustmentPublicId, apiAccessToken) => {
  try {
    const response = await axios.delete(
      `${baseUrl}/IndexAdjustment/delete-index-adjustment/${indexAdjustmentPublicId}`,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Failed to delete indexAdjustment"
    );
  }
};